import "@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css";
import "@trp-beacon-ui-kit/foundation/fonts/fonts.css";
import reactBeaconButton from "@trp-beacon-ui-kit/foundation/dist/react/beacon-button";
import reactBeaconModal from "@trp-beacon-ui-kit/foundation/dist/react/beacon-modal";
import reactBeaconFooter from "@trp-beacon-ui-kit/foundation/dist/react/beacon-footer";
import reactBeaconNavigationFooter from "@trp-beacon-ui-kit/foundation/dist/react/beacon-navigation-footer";
import reactBeaconSocialLink from "@trp-beacon-ui-kit/foundation/dist/react/beacon-social-link";
import reactBeaconSocialLinkContainer from "@trp-beacon-ui-kit/foundation/dist/react/beacon-social-link-container";
import reactBeaconIcon from "@trp-beacon-ui-kit/foundation/dist/react/beacon-icon";
import reactBeaconGaugeChart from "@trp-beacon-ui-kit/foundation/dist/react/beacon-gauge-chart";
import reactBeaconIconButton from "@trp-beacon-ui-kit/foundation/dist/react/beacon-icon-button";

// Prefix value to remove conflict with other component
const projectNamePrefix = "ric";

// Registered Beacon Components

export const RicBeaconButton = reactBeaconButton(projectNamePrefix);
export const RicBeaconModal = reactBeaconModal(projectNamePrefix);
export const RicBeaconFooter = reactBeaconFooter(projectNamePrefix);
export const RicBeaconNavigationFooter = reactBeaconNavigationFooter(
  projectNamePrefix
);
export const RicBeaconSocialLink = reactBeaconSocialLink(projectNamePrefix);
export const RicBeaconSocialLinkContainer = reactBeaconSocialLinkContainer(
  projectNamePrefix
);
export const RicBeaconIcon = reactBeaconIcon(projectNamePrefix);
export const RicBeaconGaugeChart = reactBeaconGaugeChart(projectNamePrefix);
export const RicBeaconIconButton = reactBeaconIconButton(projectNamePrefix);

const Registry = {
  RicBeaconButton,
  RicBeaconGaugeChart,
  RicBeaconModal,
  RicBeaconFooter,
  RicBeaconNavigationFooter,
  RicBeaconSocialLinkContainer,
  RicBeaconSocialLink,
  RicBeaconIcon,
  RicBeaconIconButton,
};

export default Registry;
